module.exports = {"TXTCLI_Preview":{"id":"TXTCLI_Preview","defaultMessage":"Gennemse"},"TXTCLI_Report_3":{"id":"TXTCLI_Report_3","defaultMessage":"Rapport"}}